import moment from 'moment'

export default {
  disableDay: moment().add(3, 'months'),
  dayFormat: 'YYYY-MM-DD',
  timeFormat: 'YYYY-MM-DD HH:mm:ss'
}


// WEBPACK FOOTER //
// ./src/utils/general-setup.js